(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-psp-site-header]').forEach(header => {
      if (header.dataset.pspMenuReady) return;
      const toggle = header.querySelector('[data-psp-menu-toggle]');
      const menu = header.querySelector('[data-psp-site-menu]');
      if (!toggle || !menu) return;
      const compact = window.matchMedia('(max-width: 1023px)');
      const controller = new AbortController();
      const { signal } = controller;
      const setOpen = (open, restoreFocus = false) => {
        const expanded = compact.matches && open;
        toggle.setAttribute('aria-expanded', String(expanded));
        header.classList.toggle('is-menu-open', expanded);
        menu.inert = compact.matches && !expanded;
        if (menu.inert) menu.setAttribute('aria-hidden', 'true');
        else menu.removeAttribute('aria-hidden');
        if (restoreFocus) toggle.focus({ preventScroll: true });
      };
      toggle.hidden = false;
      header.dataset.pspMenuReady = 'true';
      setOpen(false);
      toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'), { signal });
      menu.addEventListener('click', event => {
        if (event.target.closest('a')) setOpen(false);
      }, { signal });
      document.addEventListener('click', event => {
        if (!header.contains(event.target)) setOpen(false);
      }, { signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          event.preventDefault();
          setOpen(false, true);
        }
      }, { signal });
      header.addEventListener('focusout', event => {
        if (!header.contains(event.relatedTarget)) setOpen(false);
      }, { signal });
      compact.addEventListener('change', () => setOpen(false), { signal });
      window.addEventListener('resize', () => setOpen(false), { signal, passive: true });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(header)) controller.abort();
      }, { signal });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
